import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

export default function WhatsAppButton() {
  const { whatsappLink } = useSiteData();
  const t = useT();
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noreferrer"
      aria-label={t("comun.whatsapp_flotante")}
      className="fixed bottom-5 right-5 z-50 group flex items-center gap-2 rounded-full bg-primary-500 text-background-50 pl-4 pr-4 h-14 shadow-lg hover:bg-primary-600 transition-all"
    >
      <span className="w-7 h-7 flex items-center justify-center">
        <i className="ri-whatsapp-line text-2xl" />
      </span>
      <span className="text-sm font-semibold whitespace-nowrap">{t("comun.whatsapp_flotante")}</span>
    </a>
  );
}
